import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Add } from '@mui/icons-material';
import { AsyncSearchableSelect } from 'shared/components/select/SearchableSelects';
import { VARIANTS } from 'shared/constants';

/**
 * @param {Object} props
 * @param {Object<string, *>} props.entity - Entity configuration object
 */
function EntityPicker({ entity }) {
  const [selectedEntity, setSelectedEntity] = useState(null);

  // Remove selection when entity type changes or options reload.
  useEffect(() => {
    setSelectedEntity(null);
  }, [entity.searchRequest]);

  const handleClick = () => {
    entity.add(selectedEntity);
    setSelectedEntity(null);
  };

  return (
    <Grid container columnSpacing={1} rowSpacing={1} sx={{ alignItems: 'center' }}>
      <Grid size={{ xs: 12, md: 8 }}>
        <AsyncSearchableSelect
          baseSearch={entity.baseSearch}
          label={entity.label}
          preloadOptions={entity.preloadOptions}
          getOptionLabel={entity.getOptionLabel}
          onChange={setSelectedEntity}
          searchRequest={entity.searchRequest}
          selectedOption={selectedEntity}
        />
      </Grid>
      <Grid>
        <Button
          startIcon={<Add />}
          variant={VARIANTS.contained}
          disabled={!selectedEntity}
          onClick={handleClick}
        >
          Add Card
        </Button>
      </Grid>
    </Grid>
  );
}

export default EntityPicker;
